import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router';

import { getSessionAccount } from '../store/root-reducer';
import { canAccessAiInsights } from '../utility/can-access-ai-insights';
import { HOME_PATH } from './paths';

const AiInsightsRoute: FC = () => {
    const account = useSelector(getSessionAccount);

    if (!canAccessAiInsights(account?.email)) {
        return <Navigate to={HOME_PATH} replace />;
    }

    return <Outlet />;
};

export default AiInsightsRoute;
